import axios from "axios"
export const registerUser = (userData) => {
    return axios.post(process.env.REACT_APP_API_URL + '/createUser', userData);
}